import React, { useContext, useState } from "react";
import brandIcon from "./brandIcon.png";
import info from "./infoColor.png";
import cardOnCard from "./cardOnCard.png";
import "./Recommender.css";
import {
  CloseOutlined,
  WhatsAppOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { RiWhatsappFill } from "react-icons/ri";
import { HiLink } from "react-icons/hi";
import { MdSms } from "react-icons/md";
import { useSearchParams } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { onecodeAPI } from "../AppConfig";
import { Modal } from "antd";
import _ from "lodash";
import cv1 from "./creditcardv1.png";
import cv2 from "./creditcardv2.png";
import airplane from "./airplane.png";
import flashLight from "./flash_light.png";
import ReactPlayer from "react-player/lazy";
import { useTranslation } from "react-i18next";
import DynamicTextFormatter from "./DynamicTextFormatter";
import ApplyModal from "./ApplyModal";
import { FeatureFlagContext } from "../FeatureFlagContext";

let lmsRefreshIntervalId = null;
export default function RecommendationCreditCard(props) {
  const { innerWidth: width, innerHeight: height } = window;
  const { t } = useTranslation();

  // const { customer } = props;
  const { partnerDetails, customer, customerDetails,partnerId,hg,coc,isCreditScoreCheck } = props;
  const { oneCode } = useContext(FeatureFlagContext); 


  const [CategoryCreditcard, setCategoryCreditcard] = React.useState(
    partnerDetails?.CategoryCreditcard || {}
  );

  
  const [tabValue, setTabValue] = React.useState(0);
  const [tabs, setTabs] = React.useState([
    "BENEFITS",
    "FEE",
    "APPLY_PROCESS",
    "T_C",
  ]);

  React.useEffect(() => {
    if (partnerDetails && partnerDetails.CategoryCreditcard) {
      setCategoryCreditcard(partnerDetails.CategoryCreditcard);
    } else {
      setCategoryCreditcard({});
    }
  }, [partnerDetails]);

  React.useEffect(() => {
    if (
      CategoryCreditcard &&
      CategoryCreditcard.applyProcess &&
      CategoryCreditcard.applyProcess.fileType
    ) {
      setTabs(["BENEFITS", "FEE", "APPLY_PROCESS", "T_C"]);
    } else if(CategoryCreditcard &&
      CategoryCreditcard.fee) {
      setTabs(["BENEFITS", "FEE", "T_C"]);
    }else setTabs(["BENEFITS","T_C"]);
  }, [CategoryCreditcard]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  let sessionPartnerDetails = JSON.parse(
    sessionStorage.getItem("partnerDetails")
  );

  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [lf5Url, setLf5Url] = useState("");
  const [responseStatus, setResponseStatus] = useState(null);
  const [play, setPlay] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [lmsInternalStatus, setLmsInternalStatus] = useState(null);
  const [brandNotEligibleReasons, setBrandNotEligibleReasons] = useState([]);
  const [isEligibleModalVisible, setIsEligibleModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [partnerLink, setPartnerLink] = useState("");


  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setPlay(false);
    setIsModalVisible(false);
  };

  const showModal2 = () => {
    setIsModalVisible2(true);
  };
  const handleCancel2 = () => {
    setIsModalVisible2(false);
  };
  const handleEligiblePopupCancel = () => {
    setIsEligibleModalVisible(false);
  };

  const openDetailFile = () => {
    let filePath = CategoryCreditcard?.applyProcess?.url;
    window.open(filePath, "_blank");
  };

  const checkNavigation = (e) => {
    if (responseStatus == 409) {
      setIsModalVisible(false);
      e.preventDefault();
    }
  };

  const onLMSBrandsClick = async () => {
    let hash = encodeURIComponent(searchParams.get("hash"));
    try {
      const res = await onecodeAPI.post(`/public/customer/verifyApi?`, {
        hash: hash,
        partnerId: partnerDetails?.id,
      });
      if (res.data?.data?.url) {
        window.open(res.data?.data?.url, "_blank");
      }
    } catch (error) {
      console.log(error, "error---");
    }
  };

  const checkLMSRecommendation = async () => {
    let hash = encodeURIComponent(searchParams.get("hash"));
    let recommendedBrands = [];
    setDataLoading(true);
    try {
      const res = await onecodeAPI.post(
        `/public/customer/lms/recommendations`,
        {
          hash: hash,
          partnerId: partnerDetails?.id,
        }
      );
      // recommendedBrands = _.get(res, `data.${locale}`, []);
      const eligibleBrands = _.get(res, `data.eligibleBrands`, []);
      const notEligiblePartners = _.get(res, `data.notEligiblePartners`, []);
      const notEligibleReasons = _.get(res, `data.message`, []);
      setBrandNotEligibleReasons(notEligibleReasons || []);
      let resStatus = _.get(res, "status", "");
      if (resStatus == 200) {
        let internalStatus = _.get(res, "data.status", null);
        setLmsInternalStatus(internalStatus);
        if (
          internalStatus == 2019 ||
          internalStatus == 2020 ||
          internalStatus == 2022
        ) {
          setDataLoading(true);
        } else {
          setDataLoading(false);
          clearInterval(lmsRefreshIntervalId);
          const isEligibleBrand = eligibleBrands?.includes(
            Number(partnerDetails?.id)
          );
          if (isEligibleBrand) {
            applyToPartner();
          } else {
            setIsEligibleModalVisible(true);
            // setBrandNotEligiblePopup(true);
          }
        }

        // setRecommendations(rec);

        // setDataLoading(false);
      }
    } catch (error) {
      console.log(error);
      setDataLoading(false);
      clearInterval(lmsRefreshIntervalId);
      // const errMsg = _.get(
      //   error,
      //   "response.data.message",
      //   "Failed to get recommendations"
      // );
      // const errStatus = _.get(
      //   error,
      //   "response.data.status",
      //   "Failed to get recommendations"
      // );
      // if (errStatus == 500) {
      //   Toaster.error("Error", errMsg);
      // }
    }
  };

  const applyToPartner = async () => {
    let response;
    let hash = encodeURIComponent(searchParams.get("hash"));
    // console.log("partnerDetails", partnerDetails);
    let partnerId = partnerDetails?.id;

    if (partnerDetails?.shareContent?.getLink) {
      setLoading(true);
      let res = await onecodeAPI.post("/public/loanwiser/shareLink", {
        hash,
        partnerId,
      });

      let l = _.get(res, "data");
      let v = l + "&req_id=%7Bclick_id%7D";
      setLoading(false);
      // window.open(v, "_blank");
      setPartnerLink(v);
      setIsModalVisible2(true);
    }else if(partnerDetails?.isExternalLeadCapture){
      let link=partnerDetails?.itemUrl
      const newLink= _.replace(link,"{{ONECODE}}",oneCode)  
      // window.open(newLink, "_blank")
      setPartnerLink(newLink);
      setIsModalVisible2(true);
    } else if (partnerDetails?.leadFlow === "LF5") {
      try {
        setLoading(true);
        let resp = await onecodeAPI.post(`public/customer/generateLink?leadSource=${isCreditScoreCheck ? "scoreCheck" : ""}`, {
          hash,
          partnerId: `${partnerId}`,
        });
        // console.log("resp===========inside if==",resp);
        if (resp?.data?.url) {
          // window.open("whatsapp://send?text=Heyy");
          setLf5Url(resp?.data?.url);
          setPartnerLink(resp?.data?.url);
          setIsModalVisible2(true);
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (error?.response?.status == 409) {
          setResponseStatus(error?.response?.status);
          setIsModalVisible2(true);
        }
        console.log(error?.response?.status);
      }
    } else {
      try {
        setLoading(true);
        response = await onecodeAPI.post(`/public/getShareLink`, {
          hash,
          partnerId,
        });
        setLoading(false);
        setPartnerLink(response.data);
        setIsModalVisible2(true);
        // window.open(response.data, "_blank");
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    }
  };

  const whatsAppMessageTemplate = `${
    customer?.fullName
  },%0ayou can simply start your application process for ${
    partnerDetails?.title
  } by clicking the link down here.%0a${encodeURIComponent(
    lf5Url
  )}%0aNote: This is a self generated link. Do not share it with anyone.`;

  // let topUps = CategoryCreditcard?.topUSPs || "";
  // console.log(topUps)
  // const topUpsArr = [];
  // const topUpsArr = topUps.split("\n");

  return (
    <div className="">
      {hg?.includes(partnerId.toString()) ? 
      <div style={{
            backgroundColor: "#FFA63E",
            borderRadius: 7,
            display: "inline-block",
            position: "relative",
            bottom: -10,
            left: 12,
            }}>
        <div style={{margin:4,color:"#FFFFFF",fontSize:12,fontWeight: "bold"}}>High Guarantee</div>
        </div> : null}
      <div className="CCCard">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div className="CCCardHeaderLogo">
            <img
              alt=""
              // src={cv1}
              src={CategoryCreditcard.cardImage}
              style={{ width: "75px", height: "100%", objectFit: "contain" }}
            />
          </div>
          <div className="CCCardHeaderDetails">
            <p
              style={{
                fontWeight: "700",
                marginRight: "5px",
                fontSize: "16px",
                marginBottom: "0px",
                lineHeight: "18px",
              }}
            >
              {CategoryCreditcard?.cardName}
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
              }}
            >
              {CategoryCreditcard?.tags &&
                CategoryCreditcard?.tags.slice(0, 2).map((tagData) => {
                  let tag = tagData;
                  if (tagData.tag) {
                    tag = tagData.tag.trim();
                  }
                  return (
                    <div
                      className="CCCardSamllCard"
                      style={{
                        boxShadow: "1.5px 1.5px #f1f1f1",
                        paddingLeft: "0px",
                        marginLeft: "0px",
                        marginTop: "0px",
                        marginRight: "8px",
                      }}
                    >
                      <span>
                        <TagIcon tag={tag} />
                      </span>

                      <span style={{ paddingLeft: "5px", color: "#7E7E7E" }}>
                        {tagData.tagName ? tagData.tagName : tagData}
                      </span>
                    </div>
                  );
                })}
            </div>
          </div>
          <div style={{ right: 0, marginLeft: "2px" }}>
            {/* <img
              alt=""
              src={brandIcon}
              style={{ width: "9px", marginTop: "-2px" }}
            /> */}
          </div>
        </div>
        <div className="CCCardBody">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span style={{ color: "#7E7E7E", textAlign: "center" }}>
              Joining Fee
            </span>
            <span style={{ color: "#696969", textAlign: "center" }}>
              {CategoryCreditcard?.joiningFee || "-"}
            </span>
          </div>
          <div className="vline" style={{ height: "50px" }}></div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span style={{ color: "#7E7E7E", textAlign: "center" }}>
              Annual Fee
            </span>
            <span style={{ color: "#696969", textAlign: "center" }}>
              {CategoryCreditcard?.annualFee || "-"}
            </span>
          </div>
        </div>

        {CategoryCreditcard?.topUSPs &&
          CategoryCreditcard?.topUSPs.map((topUp) => {
            if (topUp.trim()) {
              return (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div>
                    <span>{`⚡`}</span>
                  </div>
                  <div>
                    <span style={{ color: "#696969" }}>{` ${topUp}`}</span>
                  </div>
                </div>
              );
            }
          })}
          {coc?.includes(partnerId.toString()) ? 
          <div className="CardOnCard" style={{marginTop: 12, marginBottom: -12,color: "#000000",fontSize: 12, display: "flex" , flexDirection: "row"}}>
          <img
              alt=""
              src={cardOnCard}
              style={{
                width: "22px",
                height: "27px"
              }}
            />
          <div className="CardOnCardText" style={{color: "#000000",fontSize: 10,paddingLeft: 8}}>Apply using existing credit card for quick approval</div>
          </div> : null }

        <div className="CCCardFooter" style={{ paddingBottom: "0px" }}>
          <div style={{ width: "25%", marginRight: "20px" }}></div>
          <button
            onClick={() => {
              showModal();
              if(sessionStorage.getItem("isCreditScoreCheck")){
                window?.Moengage?.track_event("credit-score_recommendation_brand_details_click")
              }
              window?.Moengage?.track_event(
                "add-customer_customer_brand_details_click",
                {
                  customer_name: customer?.fullName,
                  customer_phonenumber: customer?.phoneNumber,
                  brand_name: CategoryCreditcard?.title,
                  brand_category: CategoryCreditcard?.subCategory,
                  // "category-level-brand_name":"",
                }
              );
            }}
            style={{
              width: "85px",
              display: "flex",
              padding: "0px 10px",
              height: "100%",
              fontWeight: "500",
              color: "#747474",
              fontSize: "14px",
              backgroundColor: "#ffffff",
              // marginRight: "10px",
              marginRight: "10px",
              borderRadius: "5px",
              paddingTop: "3px",
              alignItems: "center",
              border: "1px solid #6C63FF",
              color: "#6C63FF",
            }}
          >
            <img
              alt=""
              src={info}
              style={{
                width: "14px",
                marginTop: "0px",
                marginRight: "4px",
              }}
            />
            Details
          </button>
          <button
            onClick={() => {
              // setIsModalVisible2(true);
              // showModal();
              if (
                (!customerDetails?.email ||
                  !customerDetails?.employerName ||
                  !customerDetails?.workExperience) &&
                partnerDetails.isLMSFlow
              ) {
                onLMSBrandsClick();
              } else if (partnerDetails.isLMSFlow) {
                checkLMSRecommendation();
              } else {
                applyToPartner();
              }

              window?.Moengage?.track_event("add-customer_customer_apply", {
                customer_name: customer?.fullName,
                customer_phonenumber: customer?.phoneNumber,
                brand_name: CategoryCreditcard?.title,
                brand_category: CategoryCreditcard?.subCategory,
              });
              if(sessionStorage.getItem("isCreditScoreCheck")){
                window?.Moengage?.track_event("credit-score_recommendation_brand_apply")
              }
            }}
            style={{
              width: "77px",
              //   height: "120%",
              fontWeight: "500",
              backgroundColor: "#6C63FF",
              border: "none",
              fontSize: "14px",
              borderRadius: "5px",
              color: "#FFFFFF",
              paddingTop: "-1px",
              marginRight: "10px",
            }}
          >
            {t("addcustomertotalinformation.Apply")}
            {loading && (
              <LoadingOutlined size={"small"} style={{ marginLeft: 10 }} />
            )}
          </button>
        </div>
      </div>

      <Modal
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered={true}
        closable={false}
        bodyStyle={{
          border: "1px solid  #ECEFFD",
          justifySelf: "center",
          borderRadius: "10px",
          padding: "5px",
          backgroundColor: "#ECEFFD",
          marginTop: "50px",
        }}
        width="90%"
      >
        <div style={{ height: "50px" }}>
          <div style={{ top: -50, position: "absolute", width: "100%" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <CloseOutlined
                className="modalCloseBtn"
                onClick={handleCancel}
                style={{
                  backgroundColor: "#fff",
                  alignSelf: "flex-end",
                  padding: "5px",
                  borderRadius: "25px",
                  position: "absolute",
                  bottom: "50px",
                  right: "10px",
                }}
              />
              <img
                alt=""
                // src={cv1}
                src={CategoryCreditcard.cardImage}
                style={{ width: "150px", height: "100%", alignSelf: "center" }}
              />
            </div>
          </div>
        </div>
        <p style={{ fontWeight: "500", fontSize: "16px", textAlign: "center" }}>
          {CategoryCreditcard?.cardName}
        </p>
        <Box
          style={{
            backgroundColor: "#fff",
            borderRadius: "5px",

            paddingBottom: 15,
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            // allowScrollButtonsMobile
            aria-label="scrollable auto tabs example"
            // sx={{
            //   "& .MuiTabScrollButton-root": {
            //     width: "25px",
            //   },
            // }}
            style={{ marginLeft: 15, marginRight: 15 }}
          >
            <Tab
              label="BENEFITS"
              sx={{
                paddingLeft: "3px",
                paddingRight: "3px",
                paddingTop: "8px",
                paddingBottom: "0px",
                minWidth: "50px",
              }}
            />
            {CategoryCreditcard &&
            CategoryCreditcard.fee ? (
            <Tab
              label="FEE"
              sx={{
                paddingLeft: "3px",
                paddingRight: "3px",
                paddingTop: "8px",
                paddingBottom: "0px",
                minWidth: "50px",
              }}
            />) : null}
            {CategoryCreditcard &&
            CategoryCreditcard.applyProcess &&
            CategoryCreditcard.applyProcess.fileType ? (
              <Tab
                label="APPLY PROCESS"
                sx={{
                  paddingLeft: "3px",
                  paddingRight: "3px",
                  paddingTop: "8px",
                  paddingBottom: "0px",
                  minWidth: "50px",
                }}
              />
            ) : null}

            <Tab
              label="T&C"
              sx={{
                paddingLeft: "3px",
                paddingRight: "3px",
                paddingTop: "8px",
                paddingBottom: "0px",
                minWidth: "50px",
              }}
            />
          </Tabs>
          <div
            style={{
              height: height ? `${(height / 100) * 60}px` : "300px",
              overflow: "scroll",
              paddingTop: "10px",
              paddingLeft: 15,
              paddingRight: 15,
            }}
          >
            {tabs[tabValue] == "BENEFITS" ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                {CategoryCreditcard.benefits &&
                  CategoryCreditcard.benefits.map((benefit) => {
                    const tag = benefit.tag;
                    return (
                      <>
                        <div
                          className="CCCardSamllCard"
                          style={{
                            padding: "2px",
                            paddingLeft: "5px",
                            paddingRight: "5px",
                            fontWeight: "bold",
                            backgroundColor: "rgba(67, 152, 209, 0.1)",
                          }}
                        >
                          <span>
                            <TagIcon tag={tag} />
                          </span>
                          <span style={{ paddingLeft: "4px" }}>
                            {benefit.heading}
                          </span>
                        </div>
                        <div
                          style={{ paddingLeft: "5px", paddingBottom: "10px" }}
                        >
                          {benefit.subText &&
                            benefit.subText.map((subText) => {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  <span>{`⚡`}</span>
                                  <span
                                    style={{
                                      color: "#696969",
                                      paddingLeft: "5px",
                                    }}
                                  >
                                    {`${subText}`}
                                  </span>
                                </div>
                              );
                            })}
                        </div>
                      </>
                    );
                  })}
              </div>
            ) : null}
            {tabs[tabValue] == "FEE" ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                {CategoryCreditcard.fee &&
                  CategoryCreditcard.fee.map((fee) => {
                    return (
                      <>
                        <div
                          className="CCCardSamllCard"
                          style={{
                            padding: "2px",
                            paddingLeft: "0px",
                            paddingRight: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          <span>{fee.heading}</span>
                        </div>
                        <div style={{ paddingLeft: "5px" }}>
                          {/* <ul style={{ paddingLeft: "15px" }}>
                          <li>Coffee</li>
                          <li>Tea</li>
                          <li>Milk</li>
                        </ul> */}
                          <ul style={{ paddingLeft: "15px" }}>
                            {fee.subText &&
                              fee.subText.map((subText) => {
                                return (
                                  <li>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <span style={{ color: "#696969" }}>
                                        {subText}
                                      </span>
                                    </div>
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                      </>
                    );
                  })}
              </div>
            ) : null}

            {tabs[tabValue] == "APPLY_PROCESS" ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                {CategoryCreditcard.applyProcess.fileType == "pdf" ? (
                  <>
                    <div
                      onClick={() => {
                        openDetailFile();
                      }}
                      style={{ position: "relative" }}
                    >
                      <img
                        alt=""
                        src={CategoryCreditcard.applyProcess.thumbnailUrl}
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "contain",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          bottom: "8px",
                          right: "0px",
                          backgroundColor: "#fff",
                          borderRadius: "5px",
                          paddingLeft: "5px",
                          paddingRight: "5px",
                          color: "rgb(108, 99, 255)",
                        }}
                      >
                        View
                      </div>
                    </div>
                  </>
                ) : null}

                {CategoryCreditcard.applyProcess.fileType == "video" ? (
                  <ReactPlayer
                    url={`https://www.youtube.com/watch?v=${CategoryCreditcard.applyProcess.url}`}
                    controls={true}
                    playing={play}
                    width="100%"
                    className="react-player"
                    height={200}
                    style={{ marginTop: 20 }}
                    light={CategoryCreditcard.applyProcess.thumbnailUrl}
                    onPlay={() => {
                      setPlay(true);
                    }}
                  />
                ) : null}
              </div>
            ) : null}
            {tabs[tabValue] == "T_C" ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                {CategoryCreditcard.customerTNC &&
                  CategoryCreditcard.customerTNC.map((tc) => {
                    return (
                      <>
                        <div
                          className="CCCardSamllCard"
                          style={{
                            padding: "2px",
                            paddingLeft: "0px",
                            paddingRight: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          <span>{tc.heading}</span>
                        </div>
                        <div style={{ paddingLeft: "5px" }}>
                          {/* <ul style={{ paddingLeft: "15px" }}>
                          <li>Coffee</li>
                          <li>Tea</li>
                          <li>Milk</li>
                        </ul> */}
                          <ul style={{ paddingLeft: "15px" }}>
                            {tc.subText &&
                              tc.subText.map((subText) => {
                                return (
                                  <li>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <span style={{ color: "#696969" }}>
                                        {subText}
                                      </span>
                                    </div>
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                      </>
                    );
                  })}
              </div>
            ) : null}
          </div>
          <div style={{ textAlign: "center" }}>
            <button
              onClick={() => {
                handleCancel();
                if (
                  (!customerDetails?.email ||
                    !customerDetails?.employerName ||
                    !customerDetails?.workExperience) &&
                  partnerDetails.isLMSFlow
                ) {
                  onLMSBrandsClick();
                } else if (partnerDetails.isLMSFlow) {
                  checkLMSRecommendation();
                } else {
                  applyToPartner();
                }
                // showModal();
                window?.Moengage?.track_event("add-customer_customer_apply", {
                  customer_name: customer?.fullName,
                  customer_phonenumber: customer?.phoneNumber,
                  brand_name: CategoryCreditcard?.title,
                  brand_category: CategoryCreditcard?.subCategory,
                });
                if(sessionStorage.getItem("isCreditScoreCheck")){
                  window?.Moengage?.track_event("credit-score_recommendation_brand_apply")
                }
              }}
              style={{
                width: "90%",
                fontWeight: "500",
                backgroundColor: "#6C63FF",
                border: "none",
                fontSize: "14px",
                borderRadius: "5px",
                color: "#FFFFFF",
                padding: "5px",
              }}
            >
              Apply
            </button>
          </div>
        </Box>
      </Modal>
      <ApplyModal
          isModalVisible={isModalVisible2}
          handleCancel={handleCancel2}
          responseStatus={responseStatus}
          partnerDetails={partnerDetails}
          setIsModalVisible={setIsModalVisible}
          customer={customerDetails}
          link={lf5Url}
          buttonToDisplay={partnerDetails?.attributionType == "WEB" ? "continue" : "whatsapp"}
          partnerLink={partnerLink}
        />
      {/* <Modal
        visible={isModalVisible2}
        onCancel={handleCancel2}
        footer={null}
        centered={true}
        closable={true}
        bodyStyle={{
          border: "1px solid  #fff",
          justifySelf: "center",
          borderRadius: "10px",
          padding: "20px",
        }}
        width="90%"
        closeIcon={<CloseOutlined className="modalCloseBtn" />}
      >
        <p
          style={{
            textAlign: "center",
            fontSize: "15px",
            color: "#7D7D7D",
          }}
        >
          {responseStatus == 409 ? (
            <DynamicTextFormatter
              textString={t("recommendation.AlreadyApplied")}
              values={{
                __PartnerTitle__: { value: partnerDetails?.title },
              }}
            />
          ) : (
            <>
              <p></p>
            </>
          )}
        </p>

        {responseStatus !== 409 && (
          <div
            style={{
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <button
              onClick={() => {
                if (responseStatus == 409) {
                  setIsModalVisible2(false);
                } else {
                  window.open(
                    `whatsapp://send?text=${whatsAppMessageTemplate}&phone=+91${customer?.phoneNumber}`
                  );
                }
              }}
              style={{
                background: "#00c34e",
                borderRadius: "5px",
                textAlign: "center",
                justifyContent: "center",
                border: "none",
                padding: "0.5rem",
                paddingLeft: "0.9rem",
                paddingRight: "0.9rem",
              }}
            >
              <p
                style={{
                  color: "#6C63FF",
                  fontSize: "15px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 0,
                  padding: 0,
                }}
              >
                {responseStatus == 409 ? (
                  "Ok"
                ) : (
                  <>
                    <RiWhatsappFill
                      style={{
                        color: "#FFF",
                        // color: "#25D366",
                        fontSize: "15px",
                      }}
                    />
                    <p
                      style={{
                        color: "#FFF",
                        fontSize: "15px",
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        marginBottom: 0,
                        padding: 0,
                        marginLeft: "5px",
                      }}
                    >
                      Generate Link
                    </p>
                  </>
                )}
              </p>
            </button>
          </div>
        )}
      </Modal> */}

      {isEligibleModalVisible && (
        <Modal
          visible={isEligibleModalVisible}
          onCancel={handleEligiblePopupCancel}
          footer={null}
          centered={true}
          closable={true}
          bodyStyle={{
            border: "1px solid  #fff",
            justifySelf: "center",
            borderRadius: "10px",
            padding: "20px",
          }}
          width="90%"
          closeIcon={<CloseOutlined className="modalCloseBtn" />}
        >
          <p
            style={{
              textAlign: "center",
              fontSize: "15px",
              color: "#7D7D7D",
              fontWeight: "bold",
            }}
          >
            Not Eligible
          </p>
          {brandNotEligibleReasons?.map((item, key) => (
            <p
              style={{
                textAlign: "center",
                fontSize: "15px",
                color: "#7D7D7D",
              }}
            >
              {key + 1}. {item}
            </p>
          ))}
        </Modal>
      )}
    </div>
  );
}

const TagIcon = ({ tag }) => {
  const [tagIconData, setTagIconData] = React.useState("");
  React.useEffect(() => {
    let newTagIconData = "";
    if (tag == "Shopping") {
      newTagIconData = "🛒";
    } else if (tag == "Savings") {
      newTagIconData = "💸";
    } else if (tag == "Travel") {
      newTagIconData = "✈️";
    } else if (tag == "Rewards") {
      newTagIconData = "🏆";
    } else if (tag == "Fuel") {
      newTagIconData = "⛽";
    } else if (tag == "Fitness") {
      newTagIconData = "🏋️";
    } else if (tag == "Dine-In") {
      newTagIconData = "🍽️";
    } else if (tag == "Movies") {
      newTagIconData = "🎬";
    } else if (tag == "Easy credit") {
      newTagIconData = "💳";
    } else if (tag == "Commute") {
      newTagIconData = "🚗";
    } else if (tag == "Milestone") {
      newTagIconData = "🏆";
    } else if (tag == "Welcome gifts") {
      newTagIconData = "🙏";
    } else if (tag == "Food") {
      newTagIconData = "🍴";
    } else if (tag == "Daily spends") {
      newTagIconData = "🏷️";
    } else if (tag == "Other") {
      newTagIconData = "🎁";
    } else if (tag == "Application") {
      newTagIconData = "📄";
    } else if (tag == "Instant Approval") {
      newTagIconData = "📝";
    }

    setTagIconData(newTagIconData);
  }, [tag]);
  return tagIconData;
};
